import axios from 'axios';
import authConfig from "src/configs/auth"
import { toast } from "react-hot-toast"
import { PublicRoutes } from 'src/utils/constants';

export const axiosInstance = axios.create({
    headers: {
        "Content-Type": "application/json",
        "authorization": `Bearer ${localStorage.getItem(authConfig.storageTokenKeyName)}`,
        'env': 'test'
    },
    withCredentials: true
});


// You can set default headers like Content-Type here
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

// Add a request interceptor to set the authorization header
axiosInstance.interceptors.request.use(
    (config) => {
        // Get the token from localStorage and set the authorization header
        const token = window.localStorage.getItem(authConfig.storageTokenKeyName);
        const userId = window.localStorage.getItem(authConfig.storageUserIdKeyName);
        if (token) {
            config.headers['authorization'] = `Bearer ${token}`;
        } if (userId) {
            config.headers['userId'] = `${userId}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add an interceptor to handle 401 responses - Invalid/Expired token
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Get current pathname
            const currentPath = window.location.pathname;
            
            // Routes that should not trigger logout/clear user data
            const paymentRoutes = [
                '/subscription/cancel',
                '/subscription/success'
            ];
            
            // Check if we're on a payment route or in a popup window
            const isPaymentRoute = paymentRoutes.some(route => currentPath.includes(route));
            const isPopupWindow = window.opener && !window.opener.closed;
            
            // Don't clear user data if:
            // 1. We're on a payment route (cancel/success)
            // 2. We're in a popup window (payment popup)
            // 3. We're on a public route
            if (!isPaymentRoute && !isPopupWindow && !PublicRoutes.includes(currentPath)) {
                // Only clear user data for legitimate authentication failures
                // Check if token exists - if it doesn't, don't clear (already logged out)
                const token = window.localStorage.getItem(authConfig.storageTokenKeyName);
                if (token) {
                    window.localStorage.removeItem(authConfig.storageUserDataKeyName);
                    window.localStorage.removeItem(authConfig.storageTokenKeyName);
                    toast.error('Session expired. Please log in again.');
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

// access token ->  8hr
// refresh token -> 90 days

